import { Stepper } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

import {
  SvgStepCompleted,
  SvgStepDefault,
  SvgStepError,
  SvgStepLoader,
} from '@/components/Create_V2/components/TaskList/icon';
import { StepComponentType } from '@/types/step';

import StepDescription from './StepDescription';

interface StepComponentProps {
  type: StepComponentType;
  text: string;
  index?: number;
}

const StepComponent = ({ index, text, type }: StepComponentProps) => {
  const isFailed = type === 'failed';
  const stepDescription = <StepDescription text={text} color={isFailed ? 'red' : ''} />;

  if (type === 'loading') {
    return (
      <Stepper.Step
        key={index}
        color="gray.2"
        icon={
          <span className="animate-spin">
            <SvgStepLoader />
          </span>
        }
        description={stepDescription}
      />
    );
  }
  if (type === 'success') {
    return (
      <Stepper.Step key={index} color="gray.2" completedIcon={<SvgStepCompleted />} description={stepDescription} />
    );
  }
  if (isFailed) {
    return <Stepper.Step key={index} color="gray.2" completedIcon={<SvgStepError />} description={stepDescription} />;
  }

  // normal
  return <Stepper.Step key={index} color="gray.2" icon={<SvgStepDefault />} description={stepDescription} />;
};

export default StepComponent;
